import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { IconsService } from '../../services/icons.service';
import { LdsUserService } from '../../services/lds-user.service';
import { LdsPrebuiltWschatService } from '../../lds-websocket-module/pre-built/lds-prebuilt-wschat.service';
import { WebsocketService } from '../../lds-websocket-module/websocket/websocket.service';
import { WsChatService } from '../../lds-websocket-module/ws-chat/ws-chat.service';
import { WsPacketService } from '../../lds-websocket-module/ws-packet/ws-packet.service';
import { WebSocketPacket } from '../../interfaces/all';
import { LwProductService } from '../../lw-product/lw-product.service';
import { Router } from '@angular/router';

@Component({
    selector: 'ds-battery-device',
    templateUrl: './battery-device.component.html',
    styleUrls: ['./battery-device.component.scss'],
    standalone: false
})
export class BatteryDeviceComponent implements OnInit {

  @Input() featureSet: any;

  batteryLevel;

  ngClass = "device-container";

  constructor (private router: Router, public user: LdsUserService, public icons: IconsService, private wsChat: WsChatService, private wsPacket: WsPacketService, private product: LwProductService) {

  }

  async ngOnInit(){
    this.batteryLevel = this.user.features[this.featureSet.batteryFeature];
    if(this.batteryLevel.attributes.value >= 75){
      this.ngClass = "device-container high";
    }else if(this.batteryLevel.attributes.value >= 25){
      this.ngClass = "device-container middle";
    }else{
      this.ngClass = "device-container low";
    }
  }

  onClick(){
    const productCode = this.featureSet.productCode;
    const deviceType = this.product.findType(productCode);
    const baseUrl = "/data-studio/detail/"
    switch(deviceType){
      case "Smart Wirefree":
        this.router.navigate([`${baseUrl}/wire-free/${this.featureSet.groupId}`]);
        break;
      case "Magnetic Trigger":
        this.router.navigate([`${baseUrl}/switch/${this.featureSet.groupId}`]);
        break;
      case "Smart Heating":
        this.router.navigate([`${baseUrl}/temperature/${this.featureSet.groupId}`]);
        break;
      default:
        break;    
    }
  }



}
